<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer">
        <v-card class="overview" elevation="0">
            <v-card-title class="pa-0">
                <v-container style="min-height:200px;" class="topbg">
                <v-row>
                    <v-col
                    cols="12"
                    md="12"
                    color="white--text"
                    class="text-center mt-5 mb-5"
                    style="color:#fff;"
                    >
                    Welcome to Juzzap
                    <br />
                    <span class style="font-size:16px;">A NEW PARADIGM</span>
                    </v-col>
                </v-row>
                </v-container>

                <v-row class="pwa-content">
                <v-col cols="12" md="12" class="text-center">
                    <img :src="juzzapLogo" width="100" />
                </v-col>
                </v-row>


            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" class="text-center " style="color:#000">
                        <h2 class="display-1">Create Your Free <br>Personal Account</h2>
                        </v-col>

                    </v-row>
                    <v-row align="" justify="center">
                        <v-col cols="12" sm="8" md="4">
                            <v-card class="" tile flat>

                                <v-card-text>
                                    <v-form id="registerform" autocomplete="off" >
                                       <input type="hidden" autocomplete="false"/>
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                v-model="firstName"
                                                label="First Name"
                                                name="firstName"
                                                prepend-icon="person"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('firstName')"
                                                data-vv-name="firstName"
                                                required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                v-model="lastName"
                                                label="Last Name"
                                                name="lastName"
                                                prepend-icon="person"
                                                type="text"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('lastName')"
                                                data-vv-name="lastName"
                                                required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                v-model="email"
                                                label="E-mail"
                                                autocomplete="off"
                                                name="email"
                                                prepend-icon="mail"
                                                type="email"
                                                v-validate="'required|email'"
                                                :error-messages="errors.collect('email')"
                                                data-vv-name="email"
                                                required
                                                ></v-text-field>
                                            </v-col>


                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                autocomplete="new-password"

                                                v-model="password"
                                                type="password" name="password"
                                                prepend-icon="fa-unlock-alt"
                                                label="Password" v-validate="'required|min:6'"
                                                :error-messages="errors.collect('password')"
                                                data-vv-name="password" ref="password"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                autocomplete="new-password"

                                                v-model="password_confirmation"
                                                type="password" name="password_confirmation"
                                                prepend-icon="fa-unlock-alt"
                                                label="Confirm Password" v-validate="'required|confirmed:password'"
                                                :error-messages="errors.collect('password_confirmation')"
                                                data-vv-name="password_confirmation"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>


                                            <v-col cols="12" md="12" >
                                                <v-checkbox
                                                v-model="keeplist"
                                                name="keeplist"
                                                label="Save my preferences and make a list of business I have visited so I can quickly find them"
                                                value="1"
                                                class="txt-color"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('keeplist')"
                                                data-vv-name="keep listing"
                                                required
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12" md="12" >
                                                <v-checkbox
                                                v-model="confirmation"
                                                name="confirmation"
                                                label="Tck to confirm your full acceptance to the Terms & Conditions"
                                                value="1"
                                                class="txt-color"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('confirmation')"
                                                data-vv-name="confirmation"
                                                required
                                                ></v-checkbox>
                                            </v-col>

                                        </v-row>



                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <div class="flex-grow-1"></div>
                                    <v-btn color="primary" large block @click.prevent="register">Login</v-btn>
                                    <!-- <v-btn color="primary" @click.prevent="submit">Login</v-btn> -->
                                    </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import Vue from 'vue'
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
export default {
 props: {
    source: String
  },
  data: () => ({
      juzzapLogo: require("@/assets/logo-Copy.png"),
      keeplist:'',
      confirmation:'',
      code:"",
      firstName:"",
      lastName:"",
      email:"",
      phone:"",

      address:"",
      password: "",
      password_confirmation: "",
      geders:[{name:"Male",value:"Male"},{name:"Female",value:"Female"}],
      dictionary: {
      attributes: {
        email: "E-mail Address"
        // custom attributes
      },
      custom: {},
      usert:[],

      authFailed: false,
        authMessage: "",
    }
  }),
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  created() {
     if (this.$route.params.code) {
      this.code = this.$route.params.code;
    }
  },
  computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    }

  },
   methods:
   {
       getCookie(cname)
    {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    },
       register()
       {
           let th = this;
           if (this.$validator.validateAll())
           {
               let fd = new FormData(document.getElementById("registerform"));


               this.$http
                .post(this.$apidomain+"register", fd)
                .then(res => {
                    if(res.data.success)
                    {

                        let email = this.email;
                        let password = this.password;
                        this.$store
                            .dispatch("loginuser", { email, password })
                            .then(() => {
                            if (this.isAuthorised)
                            {

                                this.authFailed = false;
                                this.authMessage='';

                                let user = JSON.parse(localStorage.getItem("user") || "{}");
                                    if (Object.keys(user).length !== 0)
                                    {
                                        // if (user.userType == "agent")
                                        // {
                                        //     this.$router.push("/agent/dashboard");
                                        // }
                                        // if(user.userType=='business')
                                        // {
                                        //     this.$router.push("/business/dashboard");
                                        // }
                                        if(user.userType=='user')
                                        {
                                            console.log("use");
                                            if (this.code!='')
                                            {
                                            this.$router.push({name:'businesshome',params:{code: this.code}});
                                            }else{
                                                if(this.getCookie('jzuserkey')!='')
                                                {
                                                this.$router.push({name:'userdashboard',params:{ukey: this.getCookie('jzuserkey')}});
                                                }
                                                else
                                                {
                                                this.$router.push({name:'userdashboard'});

                                                }

                                            }

                                            //this.$router.push("/businesshome");
                                        }
                                    }

                            }
                    else
                    {
                        this.authFailed = true;
                        this.authMessage="User not registered";
                        console.log('error');
                    }
                })
                .catch(err => {
                console.log('err section');
                this.authFailed = true;
                if (!err.data.success) {
                    this.authMessage = err.data.message;
                }
                });

                        //this.$router.push("/login");
                         this.$router.push({name:'businesshome',params:{code:  this.code}});

                    }
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        this.overlay=false;
                        alert(errmsg[0]);

                    }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });

           }

       }
   },
}
</script>
<style scoped>
.topbg {
  background: #fe5800;
}
.pwa-content {
  margin-top: -63px;
}
.txt-color
{

    color: #7697A1;
}
</style>
